<template>
    <div>
        <vs-row class="p-4">
            <vs-col w="12" class="lineTitulo mb-2">
                <h5><strong>GESTIÓN DE ACCESOS</strong></h5>
            </vs-col>
            <vs-col w="12">
                <vs-button
                    flat
                    class="ml-auto my-2"
                    @click="getAccesoAlumno()"
                >
                    Crear acceso a alumno
                </vs-button>
                <vs-button
                    flat
                    color="#7d33ff"
                    class="ml-auto my-2"
                    @click="getAccesosFamiliares()"
                >
                    Crear acceso a familiares
                </vs-button>
            </vs-col>
            <vs-col w="12" v-for="(user, i) in info_general" :key="i" class="pb-2 pt-3 divisorWithLine">
                <vs-row style="align-items: center;">
                    <vs-col sm="12" lg="5">
                        <label>Nombre *</label>
                        <vs-input
                            class="pt-0 pl-0"
                            v-model="user.name"
                            placeholder="Nombre"
                        />
                    </vs-col>
                    <vs-col sm="12" lg="5">
                        <label>Correo electrónico*</label>
                        <vs-input
                            class="pt-0 pl-0"
                            v-model="user.email"
                            placeholder="Nombre"
                        />
                    </vs-col>
                    <vs-col sm="12" lg="2" class="d-flex">
                        <vs-button
                            flat
                            @click="postEditarAccesos(user)"
                                md-menu-trigger
                        >
                            <i class="fas fa-edit"></i>
                        </vs-button>
                        <md-menu md-size="medium" md-align-trigger>
                            <vs-button
                                dark
                                border
                                 md-menu-trigger
                            >
                                <i class="fas fa-ellipsis-v"></i>
                            </vs-button>
                            <md-menu-content>
                                <md-menu-item :href="`/panel/user/${window.btoa(user.id)}`" target="_blank">Ver perfil</md-menu-item>
                                <md-menu-item @click="getRecuperarPassword(user.id)">Recuperar contraseña</md-menu-item>
                                <md-menu-item @click="getEliminarAcceso(user)">Eliminar acceso</md-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </vs-col>
                    <vs-col w="12">
                        <div class="hiperlink text-right">
                            <span @click="getSesionesUsuario(user)">Historial de sesiones</span>
                        </div>
                        <div v-if="user.informacion">
                            <div v-if="user.buscando" class="text-center">
                                <p><strong>Buscando</strong></p>
                                <md-progress-bar md-mode="indeterminate"></md-progress-bar>
                            </div>
                            <vs-table striped v-if="user.users.length">
                                <template #thead>
                                <vs-tr>
                                    <vs-th>
                                        Fecha
                                    </vs-th>
                                    <vs-th>
                                        Hora
                                    </vs-th>
                                    <vs-th>
                                        En mantenimiento
                                    </vs-th>
                                </vs-tr>
                                </template>
                                <template #tbody>
                                <vs-tr
                                    :key="j"
                                    v-for="(tr, j) in user.users"
                                    :data="tr"
                                >
                                    <vs-td>
                                        {{ tr.fecha }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.hora }}
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.mantenimiento }}
                                    </vs-td>
                                </vs-tr>
                                </template>
                            </vs-table>
                            <div class="text-center">
                                <p v-if="user.sin_informacion"><strong>No hay información</strong></p> 
                            </div>
                        </div>
                        
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import alumnos from '../../../../api/requests/alumno'
export default {
    props: [
        'general',
        'proceso'
    ],
    data(){
        return{
            nombre: [],
            email: [],
            info: [],
            activeHistorial: false,
            users: [],
            informacion: [],
            buscando: [],
            sin_informacion: [],

            info_general: []
        }
    },
    methods: {
        getInfo(){
            const vm = this
            const info = this.general.datos.accesos
            vm.info_general = []
            info.forEach(element => {
                const obj = {
                    name: element.name ? element.name : '',
                    email: element.email ? element.email : '',
                    informacion: false,
                    buscando: false,
                    sin_informacion: false,
                    users: [],
                    id: element.id ? element.id : '',
                    user_id:  element.user_id ? element.user_id : '',
                    persona_id: element.persona_id ? element.persona_id : '',
                    en_mantenimiento: element.en_mantenimiento ? element.en_mantenimiento : '',
                    contador: true
                }
                vm.info_general.push(obj)
            });
        },
        async getSesionesUsuario(user){
            if(user.contador){
                try{
                    user.informacion = true
                    user.buscando = true
                    user.contador = false
                    user.users = []
                    const {data:response} = await alumnos.getSesionesUsuario(user.id)
                    user.users = response
                    if(!user.users.length){
                        user.sin_informacion = true
                    }
                    user.buscando = false
                }catch{

                }
            }else{
                user.informacion = !user.informacion
            }
        },
        async getAccesosFamiliares(){
            try{
                const loading = this.$vs.loading()
                const params = {tipo: 'familiar'}
                const response = await alumnos.getAccesosFamiliares(params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: response.message
                })
                loading.close()
                this.$emit('refreshComponent', this.general.datos.persona_id, this.general.datos.tipo == 'alumno' ? 'alumno' : 'seguimiento')
            }catch{

            }
        },
        // async getEliminarAcceso(){
        //     try{
        //         const loading = this.$vs.loading()
        //         const params = {tipo: 'familiar'}
        //         const response = await alumnos.getAccesosFamiliares(params)
        //         this.$vs.notification({
        //             progress: 'auto',
        //             color: 'success',
        //             position: null,
        //             icon: '<i class="fas fa-check"></i>',
        //             title: 'Operación éxitosa',
        //             text: response.message
        //         })
        //         loading.close()
        //         this.$emit('refreshComponent', this.general.datos.persona_id, this.proceso)
        //     }catch{

        //     }
        // },
        async getAccesoAlumno(){
            const loading = this.$vs.loading()
            try{
                const params = {tipo: 'alumno'}
                const {data:response} = await alumnos.getAccesoAlumno(this.general.datos.persona_id, params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: response.message
                })
                loading.close()
                this.$emit('refreshComponent', this.general.datos.tipo == 'alumno' ? this.general.datos.persona_id : this.general.datos.prospecto_id,  this.general.datos.tipo == 'alumno' ? 'alumno' : 'seguimiento')
            }catch(error){
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: error.response.message
                })
            }
        },
        async getAccesosFamiliares(){
            const loading = this.$vs.loading()
            try{
                const params = {tipo: 'familiar'}
                const {data:response} = await alumnos.getAccesosFamiliares(this.general.datos.persona_id, params)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: response.message
                })
                console.log(this.general.datos)
                loading.close()
                this.$emit('refreshComponent', this.general.datos.tipo == 'alumno' ? this.general.datos.persona_id : this.general.datos.prospecto_id,  this.general.datos.tipo == 'alumno' ? 'alumno' : 'seguimiento')
            }catch(error){
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: error.response.message
                })
            }
        },
        async getRecuperarPassword(user_id){
            const loading = this.$vs.loading()
            try{
                const {data:response} = await alumnos.getRecuperarPassword(user_id)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'warn',
                    position: null,
                    text: response.message
                })
                loading.close()
            }catch(error){
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: error.response.message
                })
            }
        },
        async postEditarAccesos(user){
            const loading = this.$vs.loading()
            try{
                const formData = new FormData()
                formData.append('name', user.name)
                formData.append('username', user.email)
                formData.append('email', user.email)
                const {data:response} = await alumnos.postEditarAccesos(user.id, formData)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: response.message
                })
                loading.close()
                this.$emit('refreshComponent', this.general.datos.persona_id, this.general.datos.tipo == 'alumno' ? 'alumno' : 'seguimiento')
            }catch(error){
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: error.response.message
                })
            }
        },
        async getEliminarAcceso(user){
            const loading = this.$vs.loading()
            try{
                console.log(user)
                const {data: response} = await alumnos.getEliminarAcceso(user.id, this.general.datos.persona_id)
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    icon: '<i class="fas fa-check"></i>',
                    title: 'Operación éxitosa',
                    text: response.message
                })
                loading.close()
                this.$emit('refreshComponent', this.general.datos.persona_id, this.proceso)
            }catch(error){
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: error.response.message
                })
            }
        }
    },
    watch:{
        general(){
            this.getInfo()
        }
    }
}
</script>
<style>
.lineTitulo{
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 3%;
}
.inputTitulo label{
    padding-left: 11px;
    margin-top: 2%;
}
.hiperlink{
    color: rgb(50, 132, 240);
    font-weight: bold;
    cursor: pointer;
}
</style>
